import { siteContent } from '#app/utils/site/content'
import type { Audience } from '#app/utils/site/site-links'
import { Container } from '../primitives'
import { ClosingCta } from './ClosingCta'
import { FeatureRow } from './FeatureRow'
import { PhotoHero } from './PhotoHero'
import { TimelineTrack } from './TimelineTrack'

/**
 * The home page for one audience. `/` renders the tenant side and
 * `/landlord` the landlord side; the header pill switches between them.
 */
export function HomePage({ audience }: { audience: Audience }) {
	const features = siteContent.features[audience]
	return (
		<>
			<PhotoHero audience={audience} />
			<TimelineTrack audience={audience} />
			<section id="features" className="pb-2.5 pt-[72px] md:pb-10 md:pt-16">
				<Container>
					{features.map((feature, index) => (
						<FeatureRow key={feature.id} feature={feature} index={index} />
					))}
				</Container>
			</section>
			<ClosingCta audience={audience} />
		</>
	)
}
